import React from 'react';
import { motion } from 'framer-motion';
import { AlertTriangle, Crosshair, EyeOff, XCircle } from 'lucide-react';
const painPoints = [{
  icon: <AlertTriangle className="w-8 h-8 text-brand-green" data-id="element-99" />,
  title: 'Jugás como un diestro invertido',
  description: 'Copiás movimientos y tácticas pensadas para diestros, anulando tu ventaja natural en la cancha.'
}, {
  icon: <Crosshair className="w-8 h-8 text-brand-green" data-id="element-100" />,
  title: 'Desperdiciás tus mejores ángulos',
  description: 'No sabés cómo usar la geometría de la cancha a tu favor para forzar errores y bolas cortas.'
}, {
  icon: <EyeOff className="w-8 h-8 text-brand-green" data-id="element-101" />,
  title: 'Leés mal la cancha',
  description: 'Te posicionás mal y dejás espacios libres que tus rivales aprovechan fácilmente.'
}, {
  icon: <XCircle className="w-8 h-8 text-brand-green" data-id="element-102" />,
  title: "Jugás 'neutral'",
  description: 'En lugar de generar incomodidad constante, dejás que tus rivales jueguen cómodos y manejen el ritmo.'
}];
export function PainPoints() {
  return <section className="py-12 px-4 bg-brand-dark" data-id="element-103">
      <div className="max-w-5xl mx-auto" data-id="element-104">
        <div className="text-center mb-8" data-id="element-105">
          <h2 className="font-display text-2xl md:text-4xl text-white uppercase" data-id="element-106">
            ¿Sentís que no estás aprovechando tu{' '}
            <span className="text-brand-green" data-id="element-107">potencial</span>?
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-4 md:gap-5" data-id="element-108">
          {painPoints.map((point, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: index * 0.1
        }} className="bg-brand-card rounded-xl p-5 border border-white/5 hover:border-brand-green/40 transition-colors" data-id="element-109">
              <div className="bg-brand-green/10 w-12 h-12 rounded-full flex items-center justify-center mb-3 border border-brand-green/30" data-id="element-110">
                {point.icon}
              </div>
              <h3 className="font-display text-base md:text-lg text-white mb-1.5 uppercase" data-id="element-111">
                {point.title}
              </h3>
              <p className="font-body text-sm text-gray-400 leading-snug" data-id="element-112">
                {point.description}
              </p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}